import { RoleModel } from '@/views/system/roles/role-model';
import { AxiosResponse } from 'axios';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import http from '../config/http-common';

export const useRoleCreateStore = defineStore('role-create', () => {
  const isLoading = ref(false);
  const error = ref<Error | unknown>(null);
  const allRoles = ref([] as RoleModel[]);

  const saveRole = async (roleShort: string, roleDesc: string, siamKey: string) => {
    isLoading.value = true;

    try {
      error.value = null;
      await http.post(`/gateway-schemes/role?roleShort=${roleShort}&roleDesc=${roleDesc}&siamKey=${siamKey}`);
    } catch (err) {
      error.value = err;
    } finally {
      isLoading.value = false;
    }
  };

  const getAllRoles = async () => {
    if (allRoles.value && allRoles.value.length > 0) {
      return allRoles;
    }
    isLoading.value = true;

    try {
      error.value = null;
      const response: AxiosResponse<RoleModel[]> = await http.get('/gateway-schemes/role/all');
      allRoles.value = response.data;
    } catch (err) {
      error.value = err;
    } finally {
      isLoading.value = false;
    }
    return allRoles;
  };

  return {
    saveRole,
    getAllRoles,
    isLoading,
    error,
  };
});

export type RoleStore = ReturnType<typeof useRoleCreateStore>;
